import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiPropertyLevelOffersMessageWrapper } from 'components/infosite/shared-ui/offers/property-level-messages-wrapper';

export const PropertyLevelMessages: React.FC<{}> = () => (
  <UitkSpacing margin={{ small: { blockend: 'six' } }}>
    <div>
      <SharedUiPropertyLevelOffersMessageWrapper />
    </div>
  </UitkSpacing>
);
